export default __webpack_public_path__ + "static/media/icon_card_document.3e3228ab.svg";